import React from 'react';
import {
  FiBookOpen,
  FiBriefcase,
  FiFileText,
  FiGrid,
  FiHome,
  FiUser,
} from 'react-icons/fi';

const categoryIcons = {
  전체: FiHome,
  교육기관: FiGrid,
  '사설기관(학원)': FiBriefcase,
  '전문 개인강사': FiUser,
  '교재·출판': FiBookOpen,
  교육자료: FiFileText,
};

const MediaSidebar = ({ categories, selectedCategory, onSelect }) => (
  <aside className="ai-media-sidebar" aria-label="미디어 카테고리">
    <nav>
      {categories.map((category) => {
        const Icon = categoryIcons[category] || FiGrid;
        return (
          <button
            type="button"
            className={selectedCategory === category ? 'is-selected' : ''}
            onClick={() => onSelect(category)}
            key={category}
          >
            <Icon aria-hidden="true" />
            <span>{category}</span>
          </button>
        );
      })}
    </nav>
    <section>
      <strong>기관 홍보 채널</strong>
      <p>검증된 교육기관과 강사의 새로운 소식을 한곳에서 확인하세요.</p>
    </section>
  </aside>
);

export default MediaSidebar;
